/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HistoricalEventRequestDTO
 */
export interface HistoricalEventRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof HistoricalEventRequestDTO
     */
    batch?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalEventRequestDTO
     */
    delegatedFrom?: string;
    /**
     * 
     * @type {Date}
     * @memberof HistoricalEventRequestDTO
     */
    eventDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof HistoricalEventRequestDTO
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalEventRequestDTO
     */
    eventType?: HistoricalEventRequestDTOEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HistoricalEventRequestDTO
     */
    materialCode?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalEventRequestDTO
     */
    serialNumber?: string;
}


/**
 * @export
 */
export const HistoricalEventRequestDTOEventTypeEnum = {
    Aggregate: 'AGGREGATE',
    Create: 'CREATE',
    Destroy: 'DESTROY',
    Disaggregate: 'DISAGGREGATE',
    Reception: 'RECEPTION',
    Shipment: 'SHIPMENT'
} as const;
export type HistoricalEventRequestDTOEventTypeEnum = typeof HistoricalEventRequestDTOEventTypeEnum[keyof typeof HistoricalEventRequestDTOEventTypeEnum];


/**
 * Check if a given object implements the HistoricalEventRequestDTO interface.
 */
export function instanceOfHistoricalEventRequestDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HistoricalEventRequestDTOFromJSON(json: any): HistoricalEventRequestDTO {
    return HistoricalEventRequestDTOFromJSONTyped(json, false);
}

export function HistoricalEventRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoricalEventRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'delegatedFrom': !exists(json, 'delegatedFrom') ? undefined : json['delegatedFrom'],
        'eventDate': !exists(json, 'eventDate') ? undefined : (new Date(json['eventDate'])),
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'eventType': !exists(json, 'eventType') ? undefined : json['eventType'],
        'materialCode': !exists(json, 'materialCode') ? undefined : json['materialCode'],
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
    };
}

export function HistoricalEventRequestDTOToJSON(value?: HistoricalEventRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch': value.batch,
        'delegatedFrom': value.delegatedFrom,
        'eventDate': value.eventDate === undefined ? undefined : (value.eventDate.toISOString()),
        'eventId': value.eventId,
        'eventType': value.eventType,
        'materialCode': value.materialCode,
        'serialNumber': value.serialNumber,
    };
}

